<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <validation-observer v-slot="{ invalid }">
                <div class="section">
                    <div class="container-item shadow-bg label bh bstart fz_34">
                        <div class="ico bg-contain"></div>
                        &ensp;我的车主币：{{unusedPoints}}车主币
                    </div>
                    <validation-provider rules="required|mobile" v-slot="{ errors }" name="手机号码">
                        <van-field
                            v-model="phone"
                            class="container-item shadow-bg field-item"
                            clearable
                            maxlength="11"
                            placeholder="请输入手机号码"
                        >
                            <div slot="right-icon" class="bh bstart">
                                <zb-warning :message="errors[0]" />
                                <div slot="right-icon" class="ico-shopUser bg-contain"></div>
                            </div>
                        </van-field>
                    </validation-provider>
                    <div class="title fz_34">选择充值金额</div>
                    <div class="list container-item shadow-bg bh bbetween bwrap">
                        <div class="list-item-el" v-for="(item,index) in store.data" :key="index">
                            <div
                                class="list-item bv bc"
                                @click="itemClick(index,item)"
                                :class="{'active':index==current}"
                            >
                                <div class="text fz_34">{{item.price}}元</div>
                                <div class="money fz_22">{{item.price}}车主币</div>
                            </div>
                        </div>
                    </div>
                    <div class="bh bc">
                        <van-button
                            class="btn btn-submit-big"
                            :disabled="invalid||!(isPay)"
                            v-on:click.native="onExchangeClick(item)"
                        >充值</van-button>
                    </div>
                </div>
            </validation-observer>
        </div>
    </div>
</template>
<script>
import { feePhoneList } from "@/api/fee";
import { user } from "@/mixin/user";
import { list } from "@/mixin/list";
export default {
    mixins: [user, list],
    name: "FeePhonePay",
    data() {
        return {
            phone: "",
            current: -1,
            item: {},
            store: {
                proxy: {
                    getList: feePhoneList
                }
            }
        };
    },
    computed: {
        unusedPoints() {
            return this.userData.unusedPoints;
        },
        // 是否可以兑换
        isPay() {
            const me = this;
            let is = false;
            if (
                // 必须选中一项
                me.current > -1 &&
                // 车主币金额必须大于等于商品金额
                me.unusedPoints >= me.item.price
            ) {
                is = true;
            }
            return is;
        }
    },
    methods: {
        userLoginend() {
            this.phone = this.userData.telephone;
            this.storeLoad();
        },
        // 选中金额时
        itemClick(index, item) {
            this.current = index;
            this.item = item;
        },
        // 兑换
        onExchangeClick(item) {
            const me = this;
            me.$router.push({
                name: "CartOrderConfirm",
                params: {
                    isCart: false,
                    orderType: 1,
                    telephone: me.phone,
                    confirmList: [
                        {
                            id: item.goodsId,
                            goodsQuantity: 1,
                            goodsVM: {
                                id: item.goodsId,
                                name: item.goodsName,
                                price: item.price
                            }
                        }
                    ]
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.topbar-container {
    background-color: #f1f2f3;
    .scrollbar-container {
        .section {
            padding: 24px 30px 100px 30px;
            .container-item {
                @include border-radius(10px);
            }
            .label {
                height: 111px;
                padding: 0 30px;
                .ico {
                    width: 44px;
                    height: 44px;
                    background-image: url("~@/assets/imges/ico/user/integral.png");
                }
            }
            .field-item {
                margin-top: 24px;
                height: 105px;
                padding: 0 30px;
                /deep/.van-field__body {
                    height: 100%;
                }
                .ico-shopUser {
                    width: 40px;
                    height: 40px;
                    background-image: url("~@/assets/imges/ico/shop/user.png");
                    margin-left: 10px;
                }
            }
            .title {
                padding: 59px 0 29px 0;
            }
            .list {
                padding: 34px 38px 34px 38px;
                .list-item-el {
                    flex: 0 0 33.3%;
                    .list-item {
                        @include border-radius(12px);
                        height: 100px;
                        border: 1px solid #a0a0a0;
                        margin: 12px 22px;
                        padding: 5px 0;
                        .money {
                            color: #7b7a7a;
                        }
                        &.active {
                            border: 1px solid #ff9a2b;
                        }
                    }
                }
            }
            .btn {
                width: 460px;
                margin-top: 162px;
            }
        }
    }
}
[data-theme="app"] {
     .scrollbar-container {
        .section {
            .list {
                .list-item-el {
                    .list-item {
                        &.active {
                            border: 1px solid #c30d23;
                        }
                    }
                }
            }
        }
    }
}
</style>
